'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateEntries = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _immutable = require('immutable');

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _invariant = require('../../lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _keyPaths = require('../constants/keyPaths');

var _indexedDataInvariant = require('../invariants/indexedDataInvariant');

var _operatorInvariant = require('../invariants/operatorInvariant');

var _applyIdInvariant = require('./applyIdInvariant');

var _applyIdTransform = require('./applyIdTransform');

var _getEntry = require('./getEntry');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Update entries in IndexedAsyncData
 *
 * @param {Iterable} ids entry ids to update
 * @param {Function} operator operator to apply to data receives `id` and `data` as arguments
 * @param {IndexedAsyncData} indexedData IndexedAsyncData to update the entry in
 * @returns {IndexedAsyncData}
 */
var updateEntries = exports.updateEntries = (0, _curry2.default)(function (ids, operator, indexedData) {
  (0, _indexedDataInvariant.indexedDataInvariant)(indexedData);
  (0, _operatorInvariant.operatorInvariant)(operator);

  (0, _invariant2.default)(_immutable.Iterable.isIterable(ids), 'Expected ids to be iterable not a `%s`', typeof ids === 'undefined' ? 'undefined' : _typeof(ids));

  var reducer = function reducer(updatedEntries, id) {
    (0, _applyIdInvariant.applyIdInvariant)(id, indexedData);

    return updatedEntries.set((0, _applyIdTransform.applyIdTransform)(id, indexedData), operator(id, (0, _getEntry.getEntry)(id, indexedData)));
  };

  return indexedData.updateIn(_keyPaths.ENTRIES, function (entries) {
    return ids.reduce(reducer, entries);
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/indexed-async-data/operators/updateEntries.js
// module id = 901
// module chunks = 2 3